import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { getQueryParam, useScreenTransition } from '../../../Hooks/useScreenTransition';


export const checkQueryFilterExist = (query, filter) => {

if(query !== ""){
    return query += ("&" + filter);
}else{
    return query = filter;
}

}

const QueryFilters = ({
    setFilterStartTimestamp = () => {}, 
    filterStartTimestamp,
    setFilterEndTimestamp = () => {}, 
    filterEndTimestamp,
    setDatePeriod = () => {}, 
    datePeriod,
    setStatusFilter = () => {}, 
    statusFilter,
    setServicesFilter = () => {}, 
    servicesFilter,
    setSelectedClients = () => {}, 
    selectedClients,
    setSelectedMembers = () => {}, 
    selectedMembers,
    setSelectedLanguageFilter = () => {},
    selectedLanguageFilter,
    baseUrl= "/"
}) => {

  const {transitionTo} = useScreenTransition();

  const queryDatePeriod= getQueryParam("date");
  const queryFilterStart= getQueryParam("dateStart");
  const queryFilterEnd= getQueryParam("dateEnd");
  const queryStatusFilter= getQueryParam("status");
  const queryServicesFilter= getQueryParam("services");
  const queryClientsFilter= getQueryParam("clients");
  const queryMembersFilter= getQueryParam("members");
  const queryLanguageFromFilter= getQueryParam("languageFrom");
  const queryLanguageToFilter= getQueryParam("languageTo");


    useEffect(() => {
        if(queryFilterEnd && queryFilterStart && queryDatePeriod){
          const startTime = Number(queryFilterStart);
          const endTime = Number(queryFilterEnd);

          setFilterStartTimestamp(startTime);
          setFilterEndTimestamp(endTime);
          setDatePeriod(queryDatePeriod);
        }else{
          setDatePeriod("custom");
          setFilterStartTimestamp(null);
          setFilterEndTimestamp(null);
        }

        if(queryStatusFilter){
        setStatusFilter(queryStatusFilter);
        }else{
          setStatusFilter("");
        }

        if(queryServicesFilter){
        setServicesFilter(queryServicesFilter.split("--"));
        }else{
          setServicesFilter([]);
        }

        if(queryClientsFilter){
        setSelectedClients(queryClientsFilter.split("--"));
        }else{
          setSelectedClients([]);
        }

        if(queryMembersFilter){
        setSelectedMembers(queryMembersFilter.split("--"));
        }else{
          setSelectedMembers([]);
        }

        if(queryLanguageFromFilter){
        setSelectedLanguageFilter((prev) => ({ ...prev, languageFrom: queryLanguageFromFilter }));
        }else{
          setSelectedLanguageFilter((prev) => ({ ...prev, languageFrom: "" }));
        }

        if(queryLanguageToFilter){
        setSelectedLanguageFilter((prev) => ({ ...prev, languageTo: queryLanguageToFilter }));
        }else{
          setSelectedLanguageFilter((prev) => ({ ...prev, languageTo: "" }));
        }
    }, [queryFilterEnd, queryFilterStart, queryDatePeriod, queryStatusFilter, queryServicesFilter, queryClientsFilter, queryMembersFilter, queryLanguageFromFilter, queryLanguageToFilter])


  useEffect(() => {
    let queries = "";

    if(datePeriod && filterStartTimestamp && filterEndTimestamp){
      queries = checkQueryFilterExist(queries, `date=${datePeriod}&dateStart=${filterStartTimestamp}&dateEnd=${filterEndTimestamp}`);
    }
    if(statusFilter){
      queries = checkQueryFilterExist(queries, `status=${statusFilter}`);
    }
    if(servicesFilter && servicesFilter.length > 0){
      queries = checkQueryFilterExist(queries, `services=${servicesFilter.join("--")}`);
    }
    if(selectedClients && selectedClients.length > 0){
      queries = checkQueryFilterExist(queries, `clients=${selectedClients.join("--")}`);
    }
    if(selectedMembers && selectedMembers.length > 0){
      queries = checkQueryFilterExist(queries, `members=${selectedMembers.join("--")}`);
    }
    if(selectedLanguageFilter && selectedLanguageFilter.languageFrom){
      queries = checkQueryFilterExist(queries, `languageFrom=${selectedLanguageFilter.languageFrom}`);
    }
    if(selectedLanguageFilter && selectedLanguageFilter.languageTo){
      queries = checkQueryFilterExist(queries, `languageTo=${selectedLanguageFilter.languageTo}`);
    }
    queries !== "" && transitionTo(`${baseUrl}?${queries}`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datePeriod, filterStartTimestamp, filterEndTimestamp, statusFilter, servicesFilter, selectedClients, selectedMembers, selectedLanguageFilter])

  return (
    <div></div>
  )
}

export default QueryFilters